import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { EOfferDetailsActions, GetOfferDetails, GetOfferDetailsSuccess, GetOfferDetailsFailure } from '../actions/offer-details.actions';
import { Store } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { AbstractEffects } from '../../../shared/abstract.effects';
import { OfferVitrineService } from '../../../shared/services/offer-vitrine.service';
import { OfferDetailsInterface } from '../../../shared/models/offer-details.interface';

@Injectable()
export class OfferDetailsEffects extends AbstractEffects {

    offerId: number = null;

    constructor(
      private actions: Actions,
      private offerService: OfferVitrineService,
      public override store: Store<any>
    ) {
        super(store);
    }

    getOfferDetails = createEffect(() => this.actions.pipe(
        ofType<GetOfferDetails>(EOfferDetailsActions.GetOfferDetails),
        tap(params => { this.offerId = params.offerId; }),
        switchMap(() => this.offerService.getOfferDetails(this.offerId)),
        switchMap((response: OfferDetailsInterface) => of(new GetOfferDetailsSuccess(response))),
        catchError((error: HttpErrorResponse) => {
            if (401 === error.status || 403 === error.status) {
                this.ResendRequestWithNewToken(new GetOfferDetails(this.offerId));
            } else {
                this.DisplayMessage('error_with_retry', 400, new GetOfferDetailsFailure());
            }
            return throwError(error);
        })
    ));
}
